import React, { useContext } from "react";
import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import Context from "../../store/Context";
import { toast } from "react-toastify";
import { IoIosCloseCircle } from "react-icons/io";
import { RotatingLines } from "react-loader-spinner";
import { MdClose } from "react-icons/md";
import convertPdfToImages from "../../Services/Pdftoimage";
import { useEffect } from "react";
function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new File([u8arr], filename, { type: mime });
}
function AddExpenseModal(props) {
  const connectionUrl = process.env.REACT_APP_BACKEND_URL;
  //   const [open, setOpen] = useState(true);
  const ctx = useContext(Context);

  // console.log(ctx.currentTourDetailsData.tourDate, "currentdataaaaaa");
  const cancelButtonRef = useRef(null);
  const amountRef = useRef();
  // const expenseCategoryRef = useRef("Travel");
  const [expenseCategory, setExpenseCategory] = useState("Travel");
  const [paymentType, setPaymentType] = useState("Credit Card");
  const [imageFile, setImageFile] = useState(null);
  const descriptionRef = useRef();
  const voucherRef = useRef();
  const billImageRef = useRef(null);
  const dateRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("token"));
  const [imagePreview, setImagePreview] = useState(null);
  const [saveLoader, setSaveLoader] = useState(false);
  const [minData, setMinDate] = useState("");
  const today = new Date().toISOString().split('T')[0]; 

  useEffect(() => {
    const createdAt = ctx.currentTourDetailsData?.tourDate; // e.g., "202507/11
    let minDate = "";
    if (createdAt) {
      const [day, month, year] = createdAt.split("/");
      minDate = `${year}-${month}-${day}`; // "2025-07-11"
      setMinDate(minDate);
    }
  }, [ctx.currentTourDetailsData]);
  console.log(ctx.currentTourDetailsData?.tourDate);
  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    // Check if the file is an image
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Read file as Data URL
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set the preview image
        setImageFile(file);
      };
    }
    // Check if the file is a PDF
    else if (file && file.type === "application/pdf") {
      const mergedImage = await convertPdfToImages(file);
      if (mergedImage) {
        const imageFile = dataURLtoFile(mergedImage, "merged_bill.png");
        setImagePreview(mergedImage); // optionally show merged image
        setImageFile(imageFile); // set the merged image as the file
      }
    } else {
      alert("Please select a valid image or PDF file.");
    }
  };

  const removeImageHandler = () => {
    setImagePreview(null);
    billImageRef.current.value = null;
  };
  const saveExpenseHandler = async () => {
    setSaveLoader(true);
    let base64Image = "";

    const dateString = dateRef.current.value;

    // Convert the date string to a Date object
    const date = new Date(dateString);

    // Get day, month, and year from the Date object
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();

    // Format the date as dd/mm/yyyy
    const formattedDate = `${day}/${month}/${year}`;

    const expenseDateArray = formattedDate.split("/").map(Number);
    const tourDateArray = ctx?.currentTourDetailsData?.tourDate
      .split("/")
      .map(Number);

    if (
      expenseDateArray[2] < tourDateArray[2] || // Compare years
      (expenseDateArray[2] === tourDateArray[2] &&
        expenseDateArray[1] < tourDateArray[1]) || // Compare months
      (expenseDateArray[2] === tourDateArray[2] &&
        expenseDateArray[1] === tourDateArray[1] &&
        expenseDateArray[0] < tourDateArray[0]) // Compare days
    ) {
      toast.error(
        "Expense date can not be smaller than tour creation (tour starting) date"
      );
      setSaveLoader(false);
      return;
    }
    const formData = new FormData();
    formData.append("date", dateRef.current.value);
    formData.append("amount", amountRef.current.value);
    formData.append("expenseType", expenseCategory);
    formData.append("voucher", voucherRef.current.value);
    formData.append("paymentType", paymentType);
    formData.append("description", descriptionRef.current.value);
    formData.append("voucherId", ctx.currentTourIdData);
    formData.append("token", user.access_token);
    formData.append("domain", user.domain);

    formData.append("billImage", imageFile); // Add the file to FormData

    try {
      const response = await axios.post(
        `${connectionUrl}/user/saveExpense`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Specify multipart/form-data for file uploads
          },
        }
      );
      const res = response.data.expenseData;
      ctx.userCurrentTourExpenses(res);
      toast.success("Expense added.");
      setSaveLoader(false);
    } catch (err) {
      toast.error(err.response?.data?.msg);
      setSaveLoader(false);
    } finally {
      props.onClose();
    }
  };
  console.log(ctx.currentTourDetailsData?.createdAt);
  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={() => {
          return;
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto pt-[80px] md:pt-[20px]">
          <div className="flex min-h-full  justify-center p-4 text-center items-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 w-[100%] md:w-[500px] py-4 bg-white text-white">
                <div
                  className="fixed right-4 top-2 flex cursor-pointer font-bold underline"
                  onClick={() => {
                    props.onClose();
                    setImagePreview(null);
                  }}
                >
                  <IoIosCloseCircle className="w-[30px] h-[30px] text-blue-600"></IoIosCloseCircle>
                </div>
                <div className="text-center pb-4">
                  <div className="text-2xl font-semibold flex items-center">
                    {" "}
                    <div className="bg-gradient-to-r from-white to-blue-600  flex-1 h-[2px]"></div>
                    <div className="md:font-bold text-2xl pt-2 m-3  text-blue-600 font-medium">
                      ADD EXPENSE
                    </div>
                    <div className="bg-gradient-to-r from-blue-600 to-white  flex-1 h-[2px]"></div>
                  </div>
                  <div className="flex flex-col items-center text-black font-semibold">
                    <p className="">Date:</p>
                    <input
                      type="date"
                      className="border-2 bg-transparent w-[200px] mx-3 px-2"
                      ref={dateRef}
                      min={minData}
                       max={today}
                    ></input>
                  </div>
                </div>{" "}
                <div className="h-[60vh] overflow-auto bg-white rounded-lg shadow-lg">
                  <div className="flex flex-col sm:flex-row px-12 text-black font-semibold">
                    <div className="flex flex-col px-2 w-[100%] py-2">
                      <label>Amount</label>
                      <input
                        className="outline-none border-2 border-gray-400  bg-transparent px-2 "
                        ref={amountRef}
                        // type="phone"
                      ></input>
                    </div>
                    <div className="flex flex-col px-2 w-[100%] py-2 text-black">
                      <label className="text-black">Expense Category</label>
                      <select
                        className="outline-none border-2 border-gray-400  font-semibold bg-transparent"
                        value={expenseCategory}
                        onChange={(e) => setExpenseCategory(e.target.value)}
                      >
                        <option value="Travel" className="bg-blue-400">
                          Travel
                        </option>
                        <option value="Food(Da)" className="bg-blue-400">
                          Food
                        </option>
                        <option value="Accomondation" className="bg-blue-400">
                          Accomondation
                        </option>
                        <option value="Misc" className="bg-blue-400">
                          Misc (others)
                        </option>
                      </select>
                      <small className="text-red-500">
                        *Include food if under DA{" "}
                      </small>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row px-12 text-black font-semibold">
                    {" "}
                    <div className="flex flex-col px-2 w-[100%] py-2">
                      <label>Description</label>
                      <textarea
                        rows={3}
                        className="outline-none border-2 border-gray-400  bg-transparent px-2 "
                        ref={descriptionRef}
                      ></textarea>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row px-12 text-black font-semibold">
                    <div className="flex flex-col px-2 w-[100%] py-2">
                      <label>Bill No (if present)</label>
                      <input
                        className="outline-none border-2 border-gray-400  bg-transparent  px-2"
                        ref={voucherRef}
                      ></input>
                    </div>
                    <div className="flex flex-col px-2 w-[100%] py-2">
                      <label>Payment Type</label>
                      <select
                        className="outline-none border-2  font-semibold border-gray-400  bg-transparent"
                        value={paymentType}
                        onChange={(e) => {
                          setPaymentType(e.target.value);
                        }}
                      >
                        <option value={"Credit Card"} className="bg-blue-400">
                          Credit card
                        </option>
                        <option value={"Cash"} className="bg-blue-400">
                          Cash
                        </option>
                        <option
                          value={"Online (train/flight)"}
                          className="bg-blue-400"
                        >
                          Online(train/flight)
                        </option>
                      </select>
                    </div>
                  </div>{" "}
                  <div className="flex flex-col px-12 w-[100%] py-2 text-black font-semibold">
                    <p className="px-2">Bill Image/Pdf :</p>
                    <input
                      type="file"
                      className="border-2 bg-transparent mx-2 "
                      ref={billImageRef}
                      accept="image/*,.pdf"
                      onChange={handleImageChange}
                    ></input>

                    {imagePreview && (
                      <div className="mt-4 ">
                        <div
                          className="flex justify-end text-red-500 underline cursor-pointer"
                          onClick={removeImageHandler}
                        >
                          Remove Item
                        </div>
                        <div className="max-h-[400px] overflow-auto border rounded p-2">
                          <img
                            src={imagePreview}
                            alt="Bill Preview"
                            className="max-w-full h-auto"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w-[100%] flex  justify-center mb-4 mt-6">
                  <p
                    className="w-[80%] bg-blue-600  hover:bg-blue-700 flex  justify-center font-semibold py-3 rounded-md cursor-pointer text-white"
                    onClick={saveExpenseHandler}
                  >
                    {!saveLoader ? (
                      "Add Expense"
                    ) : (
                      <RotatingLines
                        visible={true}
                        height="24"
                        width="24"
                        strokeColor="black"
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    )}
                  </p>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default AddExpenseModal;
